import VimeoPlayer from "@vimeo/player";

/**
 * Creates play/pause listener if controls aren't visible
 */
function playVimeoVideo() {
    if ($(".vc-container").data("controls") == 0) {
        $(".vc-container__click").on("click", function () {
            var video = $(this).siblings(".vc-container__video");
            var player = new VimeoPlayer($(video[0]));
            player.getPaused().then(function (paused) {
                if (paused) {
                    player.play();
                } else {
                    player.pause();
                }
            });
        });
    }
}

function pauseVimeoVideo() {
    $(".experience-bassett_assets-videoComponent button.close").on("click", function () {
        var video = $(this).closest(".modal-content").find(".vc-container__video");

        if (video && video[0]) {
            var player = new VimeoPlayer($(video[0]));
            player.getPaused().then(function () {
                player.pause();
            });
        }
    });

}

function handlePopupToggle(popupModal, action) {
    var popupAction = action ? action.toLowerCase() : null;

    if (popupModal && popupAction) {
        var $iframeContainer = $(popupModal).find(".iframe-container");
        var $videos = $iframeContainer && $iframeContainer.length ? $iframeContainer.find("video") : null;

        // self-hosted videos
        if ($videos && $videos.length) {
            var video = $videos[0];

            if (video) {
                var $playButtons = $iframeContainer.find(".play-button");
                var playButton = $playButtons && $playButtons.length ? $playButtons[0] : null;

                if (popupAction === "show" && video.autoplay) {
                    if (playButton && video.paused) {
                        playButton.click();
                    } else {
                        video.play();
                    }
                } else if (popupAction === "hide") {
                    if (playButton && !video.paused) {
                        playButton.click();
                    } else {
                        video.pause();
                    }
                }
            }
        }

        // vimeo videos
        if ($iframeContainer && !($iframeContainer.find("*").length) && popupAction === "show") {
            var $iframe = $("<iframe/>").attr({
                src: $iframeContainer.data("src"),
                class: $iframeContainer.data("styleClass"),
                allow: "autoplay"
            });
            $iframeContainer.html($iframe);
        } else if ($iframeContainer && $iframeContainer.find(".vc-container__video").length) {
            var $vimeoVideos = $iframeContainer.find(".vc-container__video");
            var vimeoVideo = $vimeoVideos && $vimeoVideos.length ? $vimeoVideos[0] : null;
            var vimeoPlayer = vimeoVideo ? new VimeoPlayer($(vimeoVideo)) : null;

            if (vimeoPlayer) {
                var autoplayVimeoVideo = vimeoVideo.src && vimeoVideo.src.indexOf("autoplay=1") > -1;
                if (popupAction === "show" && autoplayVimeoVideo) {
                    vimeoPlayer.getPaused().then(function (paused) {
                        if (paused) {
                            vimeoPlayer.play();
                        }
                    });
                } else if (popupAction === "hide") {
                    vimeoPlayer.getPaused().then(function (paused) {
                        if (!paused) {
                            vimeoPlayer.pause();
                        }
                    });
                }
            }
        }
    }
}

$(document).ready(function () {
    playVimeoVideo();
    pauseVimeoVideo();

    $("body").on("show.bs.modal hide.bs.modal", ".experience-bassett_assets-videoComponent .modal--video", function (event) {
        handlePopupToggle(this, event.type);
    });

    // Custom play/pause for self-hosted videos
    const videoContainers = document.querySelectorAll(".iframe-container");

    videoContainers.forEach(container => {
        const video = container.querySelector("video");
        const playButton = container.querySelector(".play-button");

        if (video && playButton) {
            playButton.addEventListener("click", () => {
                if (video.paused) {
                    video.play();
                    playButton.textContent = "Pause";
                } else {
                    video.pause();
                    playButton.textContent = "Play";
                }
            });
        }
    });
});
